module.exports = __webpack_public_path__ + "static/secrets-and-flowers-of-a-warrior-in-a-sandbox_2008-05cc07edd78e52798d77210ffbc84245.jpg";